interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "KWD";
};

const KWD: Currency = Object.freeze({
  "displayName": "Kuwaiti Dinar",
  "numericCode": 414,
  "defaultFractionDigits": 3,
  "subUnit": 1000,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "KWD",
  "symbol": "د.ك"
});

export { KWD };
